export enum ERROR_CODES {
  COMPANYDATA_NOT_FOUND = 0,
  USER_DOMAIN_NOT_FOUND = 1018
}
export enum AuthErrorCodes {
  NO_COMPANY_DATA = 999,
  USER_NOT_FOUND = 997,
  NO_APP_PERMISSION = 0
}
